import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ICompany } from 'app/shared/Domains/company';
import { IBranch } from 'app/shared/Domains/branch';
import { IUser } from 'app/shared/Domains/IUser';
import { UntypedFormControl, Validators, UntypedFormGroup } from '@angular/forms';
import { Configuration } from 'config/config';
// import { isNullOrUndefined } from 'util';
import { AppServiceManager } from 'common/services/appServiceManager';
import { MessageService } from 'primeng/api';
import { Router } from '@angular/router';
import globalVariable from "../../../globalVariable/globalVariable.json";
import { HttpClient } from '@angular/common/http';
import { AppUtils } from 'common/services/app.util';
import { LanguageService } from 'app/LanguageService/Language.Service';
import { AuthService } from 'common/services/auth.service';
@Component({
  selector: 'app-register-company',
  templateUrl: './register-company.component.html',
  host: { "(window:keyup)": "hotkeys($event)", "(window:click)": "hotClick($event)" },
  styleUrls: ['./register-company.component.css']
})
export class RegisterCompanyComponent implements OnInit {
  @ViewChild('recaptcha', { static: true }) recaptchaElement: ElementRef;
  errorExempleNumber: any;
  company: ICompany;
  branch: IBranch;
  companyForm: UntypedFormGroup;
  branchForm: UntypedFormGroup;
  userForm: UntypedFormGroup;
  isCompany: boolean = true;
  indextab: number = 0;
  user: IUser;
  uploadedFiles: File[] = [];
  enterSteps: any[];
  currentStep: any = 0;
  uploadProfile: any;
  uploadProfilePath: any;
  addProfileImage: any;
  dialogVisibility: boolean;
  webcamImage: any = null;
  response: any;
  isDisableSignin: boolean = true;
  isRegistrationSuccessful: boolean = false;
  activeIndex: any;
  userdomain: any;
  companyImageFile: File = null; // Store the actual file object for multer upload

  constructor(
    private LanguageService: LanguageService,
    public configServer: Configuration,
    private navRoute: Router,
    private _http: HttpClient,
    public config: Configuration,
    private appServiceManager: AppServiceManager,
    private messageService: MessageService
  ) { }

  ngOnInit() {
    this.InitObjects();
    // this.addRecaptchaScript();
    this.activeIndex = 0;


  }
  setLabel(label) {
    return this.LanguageService.GetCurrentLanguage("RegisterCompanyComponent", label);
  }
  ngAfterViewInit() {
    document.getElementById("name").focus();
  }

  get name() { return this.companyForm.get('name'); }
  get type() { return this.companyForm.get('type'); }
  get address() { return this.companyForm.get('address'); }
  get websiteUrl() { return this.companyForm.get('websiteUrl'); }
  get phone() { return this.companyForm.get('phone'); }
  get contactPerson() { return this.companyForm.get('contactPerson'); }
  get contactPersonEmail() { return this.companyForm.get('contactPersonEmail'); }
  get whatsappApiKey() { return this.companyForm.get('whatsappApiKey'); }
  get smsUsername() { return this.companyForm.get('smsUsername'); }
  get smsPassword() { return this.companyForm.get('smsPassword'); }
  get smsSender() { return this.companyForm.get('smsSender'); }

  get branchname() { return this.branchForm.get('branchname'); }
  get domainname() { return this.branchForm.get('domainname'); }
  get branchaddress() { return this.branchForm.get('branchaddress'); }
  get branchphone() { return this.branchForm.get('branchphone'); }
  get branchwhatsapp() { return this.branchForm.get('branchwhatsapp'); }
  get branchfeewhatsapp() { return this.branchForm.get('branchfeewhatsapp'); }
  get branchvisitorwhatsapp() { return this.branchForm.get('branchvisitorwhatsapp'); }
  get branchregistrationwhatsapp() { return this.branchForm.get('branchregistrationwhatsapp'); }
  get branchcontactPerson() { return this.branchForm.get('branchcontactPerson'); }
  get branchcontactPersonEmail() { return this.branchForm.get('branchcontactPersonEmail'); }
  get branchvisitorFee() { return this.branchForm.get('branchvisitorFee'); }
  get isWhatsappEnabled() { return this.branchForm.get('isWhatsappEnabled'); }
  get gymPackage() { return this.branchForm.get('gymPackage'); }
  get isSmsEnabled() { return this.branchForm.get('isSmsEnabled'); }
  get lockDefaulterOnACT() { return this.branchForm.get('lockDefaulterOnACT'); }


  get fullname() { return this.userForm.get('fullname'); }
  get username() { return this.userForm.get('username'); }
  get useremail() { return this.userForm.get('useremail'); }
  get password() { return this.userForm.get('password'); }

  InitObjects() {
    this.errorExempleNumber = globalVariable.exampledata.pakNumber;
    this.company = new ICompany();
    this.branch = new IBranch();
    this.user = new IUser();
    this.validationCompanyForm();
    this.validationBranchForm();
    this.validationUserForm();

    if (this.indextab == 0) {
      this.enterSteps = [
        "name",
        "type",
        "contactPersonEmail",
        "websiteUrl",
        "phone",
        "contactPerson",
        "address",
        "companyNextButton",
        "whatsappApiKey",
        "smsUsername",
        "smsPassword",
        "smsSender"
      ];
    } else if (this.indextab == 1) {
      this.enterSteps = [
        "branchname",
        "domainnname",
        "branchaddress",
        "branchphone",
        "branchwhatsapp",
        "branchfeewhatsapp",
        "branchvisitorwhatsapp",
        "branchregistrationwhatsapp",
        "branchcontactPerson",
        "branchcontactPersonEmail",
        "branchvisitorFee",
        "branchNextButton",
        "isWhatsappEnabled",
        "isSmsEnabled",
        "lockDefaulterOnACT"
      ];
    } else if (this.indextab == 2) {
      this.enterSteps = [
        "fullname",
        "useremail",
        "username",
        "password",
        "registerButton",
      ];
    }
  }


  validationCompanyForm() {
    const regexNumber = /\-?\d*\.?\d{1,2}/;
    this.companyForm = new UntypedFormGroup({
      'name': new UntypedFormControl(this.company.name, [
        Validators.required,
        // Validators.minLength(4),
      ]),
      'type': new UntypedFormControl(this.company.type, [
        Validators.required,
        // Validators.minLength(4),
      ]),
      'address': new UntypedFormControl(this.company.address, [
      ]),
      'websiteUrl': new UntypedFormControl(this.company.websiteUrl, [
      ]),
      'whatsappApiKey': new UntypedFormControl(this.company.whatsappApiKey, [
      ]),
      'smsUsername': new UntypedFormControl(this.company.smsUsername, [
        Validators.pattern(/(923)[0-9]{9}$/),
      ]),
      'smsPassword': new UntypedFormControl(this.company.smsPassword, [
      ]),
      'smsSender': new UntypedFormControl(this.company.smsSender, [
      ]),
      'phone': new UntypedFormControl(this.company.phone, [
        Validators.required,
      ]),
      'contactPerson': new UntypedFormControl(this.company.contactPerson, [
        Validators.required,
        Validators.minLength(3),

      ]),
      'contactPersonEmail': new UntypedFormControl(this.company.contactPersonEmail, [
        Validators.required,
        Validators.pattern(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/)
      ]),
    });
  }

  validationBranchForm() {
    const regexNumber = /\-?\d*\.?\d{1,2}/;
    this.branchForm = new UntypedFormGroup({
      'branchname': new UntypedFormControl(this.branch.name, [
        Validators.required,
        Validators.minLength(4),
      ]),
      'domainname': new UntypedFormControl(this.branch.domain, [
        Validators.required,
      ]),
      'branchaddress': new UntypedFormControl(this.branch.address, [
        Validators.required
      ]),
      'branchphone': new UntypedFormControl(this.branch.phone, [
        Validators.required,
      ]),
      'branchwhatsapp': new UntypedFormControl(this.branch.whatsapp, [
        Validators.required,
      ]),
      'branchfeewhatsapp': new UntypedFormControl(this.branch.feeWhatsapp, [
      ]),
      'branchvisitorwhatsapp': new UntypedFormControl(this.branch.visitorWhatsapp, [
      ]),
      'branchregistrationwhatsapp': new UntypedFormControl(this.branch.registrationWhatsapp, [
      ]),
      'branchcontactPerson': new UntypedFormControl(this.branch.contactPerson, [
      ]),
      'branchcontactPersonEmail': new UntypedFormControl(this.branch.contactPersonEmail, [
        Validators.required,
        Validators.pattern(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/)
      ]),
      'branchvisitorFee': new UntypedFormControl(this.branch.visitorFee, [
      ]),
      'isWhatsappEnabled': new UntypedFormControl(this.branch.isWhatsappEnabled, [

      ]),
      'gymPackage': new UntypedFormControl(this.branch.gymPackage, [
        Validators.required,
      ]),
      'isSmsEnabled': new UntypedFormControl(this.branch.isSmsEnabled, [

      ]),
      'lockDefaulterOnACT': new UntypedFormControl(this.branch.lockDefaulterOnACT, [

      ]),

    });
  }

  validationUserForm() {
    const regexNumber = /\-?\d*\.?\d{1,2}/;
    this.userForm = new UntypedFormGroup({
      'fullname': new UntypedFormControl(this.user.name, [
        Validators.required,
        Validators.minLength(4),
      ]),
      'useremail': new UntypedFormControl(this.user.email, [
        Validators.required,
        Validators.pattern(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/)
      ]),
      'username': new UntypedFormControl(this.user.username, [
        Validators.required,
      ]),
      'password': new UntypedFormControl(this.user.password, [
        Validators.required
      ])
    });
  }

  nextform() {

    if (this.activeIndex === 0) {
      this.activeIndex++;

      // this.indextab = 1;
      // this.currentStep = -1;
      this.enterSteps = [
        "branchname",
        "domainname",
        "branchaddress",
        "branchphone",
        "branchwhatsapp",
        "branchfeewhatsapp",
        "branchvisitorwhatsapp",
        "branchregistrationwhatsapp",
        "branchcontactPerson",
        "branchcontactPersonEmail",
        "branchvisitorFee",
        "branchNextButton",
        "gymPackage",
        "isWhatsappEnabled",
        "isSmsEnabled",
        "lockDefaulterOnACT"
      ];
      const contactNumber = !this.isNullOrUndefined(this.companyForm.controls['phone']) ? this.companyForm.controls['phone'].value : '';
      this.branchForm.setValue({
        branchname: '',
        domainname: '',
        branchaddress: !this.isNullOrUndefined(this.companyForm.controls['address']) ? this.companyForm.controls['address'].value : '',
        branchphone: contactNumber,
        branchwhatsapp: contactNumber,
        branchfeewhatsapp: contactNumber,
        branchvisitorwhatsapp: contactNumber,
        branchregistrationwhatsapp: contactNumber,
        branchcontactPerson: !this.isNullOrUndefined(this.companyForm.controls['contactPerson']) ? this.companyForm.controls['contactPerson'].value : '',
        branchcontactPersonEmail: !this.isNullOrUndefined(this.companyForm.controls['contactPersonEmail']) ? this.companyForm.controls['contactPersonEmail'].value : '',
        branchvisitorFee: 0,
        isWhatsappEnabled: this.setLabel('yESValueLabel'),
        isSmsEnabled: this.setLabel('yESValueLabel'),
        gymPackage: 'standard',
        lockDefaulterOnACT: 'true',
      })

      document.getElementById("branchname").focus();

    }
    // else if (this.indextab == 1) {
    else if (this.activeIndex == 1) {
      this.activeIndex++;
      this.userdomain = this.branchForm.controls['domainname'].value;
      // this.indextab = 2;
      // this.currentStep = -1;
      this.enterSteps = [
        "fullname",
        "useremail",
        "username",
        "password",
        "registerButton",
      ];

      this.userForm.setValue({
        fullname: !this.isNullOrUndefined(this.companyForm.controls['contactPerson']) ? this.companyForm.controls['contactPerson'].value : '',
        useremail: !this.isNullOrUndefined(this.branchForm.controls['branchcontactPersonEmail']) ? this.branchForm.controls['branchcontactPersonEmail'].value : '',
        username: !this.isNullOrUndefined(this.branchForm.controls['branchcontactPersonEmail']) ? this.branchForm.controls['branchcontactPersonEmail'].value.split('@')[0] : '',
        password: 'abcd@1234',
      })
      // document.getElementById("username").focus();
    }
  }

  isNullOrUndefined(value: any) {
    return value === null || value === undefined;
  }

  setCompanyValues() {
    this.company.name = !this.isNullOrUndefined(this.companyForm.controls['name']) ? this.companyForm.controls['name'].value : '';
    this.company.type = !this.isNullOrUndefined(this.companyForm.controls['type']) ? this.companyForm.controls['type'].value : '';
    this.company.address = !this.isNullOrUndefined(this.companyForm.controls['address']) ? this.companyForm.controls['address'].value : '';
    this.company.phone = !this.isNullOrUndefined(this.companyForm.controls['phone']) ? this.companyForm.controls['phone'].value : '';
    this.company.contactPerson = !this.isNullOrUndefined(this.companyForm.controls['contactPerson']) ? this.companyForm.controls['contactPerson'].value : '';
    this.company.contactPersonEmail = !this.isNullOrUndefined(this.companyForm.controls['contactPersonEmail']) ? this.companyForm.controls['contactPersonEmail'].value : '';
    this.company.websiteUrl = !this.isNullOrUndefined(this.companyForm.controls['websiteUrl']) ? this.companyForm.controls['websiteUrl'].value : '';
    this.company.isDelete = false;
    this.company.whatsappApiKey = !this.isNullOrUndefined(this.companyForm.controls['whatsappApiKey']) ? this.companyForm.controls['whatsappApiKey'].value : '';
    this.company.smsUsername = !this.isNullOrUndefined(this.companyForm.controls['smsUsername']) ? this.companyForm.controls['smsUsername'].value : '';
    this.company.smsPassword = !this.isNullOrUndefined(this.companyForm.controls['smsPassword']) ? this.companyForm.controls['smsPassword'].value : '';
    this.company.smsSender = !this.isNullOrUndefined(this.companyForm.controls['smsSender']) ? this.companyForm.controls['smsSender'].value : '';

  }


  setBranchValues() {
    this.branch.name = !this.isNullOrUndefined(this.branchForm.controls['branchname']) ? this.branchForm.controls['branchname'].value : '';
    this.branch.domain = !this.isNullOrUndefined(this.branchForm.controls['domainname']) ? this.branchForm.controls['domainname'].value : '';
    this.branch.address = !this.isNullOrUndefined(this.branchForm.controls['branchaddress']) ? this.branchForm.controls['branchaddress'].value : '';
    this.branch.shortAddress = !this.isNullOrUndefined(this.branchForm.controls['branchaddress']) ? this.branchForm.controls['branchaddress'].value : '';
    this.branch.phone = !this.isNullOrUndefined(this.branchForm.controls['branchphone']) ? this.branchForm.controls['branchphone'].value : '';
    this.branch.contactPerson = !this.isNullOrUndefined(this.branchForm.controls['branchcontactPerson']) ? this.branchForm.controls['branchcontactPerson'].value : '';
    this.branch.contactPersonEmail = !this.isNullOrUndefined(this.branchForm.controls['branchcontactPersonEmail']) ? this.branchForm.controls['branchcontactPersonEmail'].value : '';
    this.branch.visitorFee = !this.isNullOrUndefined(this.branchForm.controls['branchvisitorFee']) ? this.branchForm.controls['branchvisitorFee'].value : '';
    this.branch.isWhatsappEnabled = !this.isNullOrUndefined(this.branchForm.controls['isWhatsappEnabled']) ? this.branchForm.controls['isWhatsappEnabled'].value : this.setLabel('yESValueLabel');
    this.branch.isSmsEnabled = !this.isNullOrUndefined(this.branchForm.controls['isSmsEnabled']) ? this.branchForm.controls['isSmsEnabled'].value : this.setLabel('yESValueLabel');
    this.branch.whatsapp= !this.isNullOrUndefined(this.branchForm.controls['branchwhatsapp']) ? this.branchForm.controls['branchwhatsapp'].value : '';
    this.branch.feeWhatsapp= !this.isNullOrUndefined(this.branchForm.controls['branchfeewhatsapp']) ? this.branchForm.controls['branchfeewhatsapp'].value : '';
    this.branch.visitorWhatsapp= !this.isNullOrUndefined(this.branchForm.controls['branchvisitorwhatsapp']) ? this.branchForm.controls['branchvisitorwhatsapp'].value : '';
    this.branch.gymPackage= !this.isNullOrUndefined(this.branchForm.controls['gymPackage']) ? this.branchForm.controls['gymPackage'].value : 'standard';
    this.branch.registrationWhatsapp= !this.isNullOrUndefined(this.branchForm.controls['branchregistrationwhatsapp']) ? this.branchForm.controls['branchregistrationwhatsapp'].value : '';
    this.branch.lockDefaulterOnACT = !this.isNullOrUndefined(this.branchForm.controls['lockDefaulterOnACT']) ? this.branchForm.controls['lockDefaulterOnACT'].value : 'true';
  }

  setUserValues() {
    this.user.name = this.userForm.controls['fullname'].value;
    this.user.username = this.userForm.controls['username'].value;
    // this.user.email = this.userForm.controls['useremail'].value;
    this.user.email = `${this.user.username}@${this.userdomain}`;
    this.user.password = this.userForm.controls['password'].value;
    this.user.profile = 'assets/layout/images/avatarBoyImage.png';

  }

  onCompanyLogoUpload($event: any) {
    if ($event.files && $event.files[0]) {
      var file = $event.files[0];
      this.uploadedFiles.push(file);
    }
  }

  // registerCompany() {
  //   this.setBranchValues();
  //   this.setUserValues();
  //   this.setCompanyValues();
  //   var obj = {
  //     company: this.company,
  //     branch: this.branch,
  //     user: this.user
  //   }
  //   let formData: FormData = new FormData();
  //   if (this.uploadedFiles.length > 0) {
  //     for (var i = 0; i < this.uploadedFiles.length; i++) {
  //       formData.append("image_", this.uploadedFiles[i], this.uploadedFiles[i].name);
  //     }
  //   }

  //   formData.append("objSignUp", JSON.stringify(obj));
  //   this.appServiceManager.post("companies/companyRegister", formData).subscribe((res: any) => {
  //     this.navRoute.navigateByUrl('/login')
  //   },
  //     (error) => {
  //       this.messageService.clear();
  //       this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
  //     });
  // }

  userSignUp() {
    alert('click')
  }

  captureImageDialogShow(type) {
    this.addProfileImage = type; // Upload | Cam
    this.dialogVisibility = true;
  }
  hideAddProfileImage() {
    this.dialogVisibility = false;
  }

  handleImagefromNewProfile(webcamImage) {
    if (webcamImage) {
      this.uploadProfile = webcamImage;
      this.company.bannerImage = webcamImage;
      // Convert base64 to File object for multer upload
      this.companyImageFile = AppUtils.base64ToFile(webcamImage, `${this.company.name || 'company'}.png`);
      this.webcamImage = null;
      this.hideAddProfileImage();
    }
  }

  profileUploader(event) {
    if (event.files && event.files[0]) {
      this.uploadProfile = event.files[0];
      this.companyImageFile = event.files[0]; // Store the actual File object
      this.company.bannerImage = this.uploadProfile.objectURL || URL.createObjectURL(event.files[0]);
    }
  }


  registerCompany() {
    if (this.isRegistrationSuccessful) {
      return;
    }
    this.setBranchValues();
    this.setUserValues();
    this.setCompanyValues();
    var obj = {
      company: this.company,
      branch: this.branch,
      user: this.user
    }
    this.appServiceManager.post('companies/company-register', obj).subscribe((res: any) => {
      const signupUser = Array.isArray(res) ? res[0] : res;
      const companyId =
        signupUser?.company?._id ?? signupUser?.company ?? signupUser?._id;

      if (signupUser) {
        this.isRegistrationSuccessful = true;
        this.messageService.clear();
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Company registration successful!'
        });

        // Upload company image using multer (FormData) if file exists
        if (this.companyImageFile) {
          this.upload(this.companyImageFile, companyId);
        } else if (this.company.bannerImage && typeof this.company.bannerImage === 'string' && this.company.bannerImage.startsWith('data:')) {
          // Fallback: convert base64 to file if file object not available
          const file = AppUtils.base64ToFile(this.company.bannerImage, `${this.company.name}.png`);
          this.upload(file, companyId);
        }

      }

    },
      (error: any) => {
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      });

  }

  upload(file: any, companyID) {
    let formData: FormData = new FormData();
    if (file) {
      // Use FormData with multer - similar to user profile upload
      formData.append("companyImage", file, file.name);
      formData.append("companyID", companyID);
      formData.append("isAddMode", "true"); // Indicate this is a new company registration

      this.appServiceManager.post("companies/upload", formData)
        .subscribe(
          (res: any) => {
            if (res && res.status) {
              this.messageService.clear();
              this.messageService.add({
                severity: 'success',
                summary: 'Success',
                detail: 'Company logo uploaded successfully!'
              });
            }
          },
          (error: any) => {
            this.messageService.clear();
            this.messageService.add({ severity: "error", summary: "Error Message", detail: error, });
          }
        );
    }
  }

  addRecaptchaScript() {
    window['grecaptchaCallback'] = () => {
      this.renderReCaptcha();
    }
    (function (d, s, id, obj) {
      var js, fjs = d.getElementsByTagName(s)[0];
      // if (d.getElementById(id)) { return; }
      js = d.createElement(s); js.id = id;
      js.src = "https://www.google.com/recaptcha/api.js?onload=grecaptchaCallback&render=explicit";
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'recaptcha-jssdk', this));

  }

  renderReCaptcha() {
    window['grecaptcha'].render(this.recaptchaElement.nativeElement, {
      'sitekey': '6LeBcNofAAAAALKEmqYmmxrDJ7Fi9IpwDAPMVCtm',
      'expired-callback': () => {
        this.isDisableSignin = true;
        document.getElementById('fullname').focus();
      },
      'callback': (response) => {
        console.log(response);
        this.response = response;
        if (response == "") {
          this.isDisableSignin = true;
        } else {
          this.isDisableSignin = false;
          document.getElementById('fullname').focus();
        }
      }
    });
  }

  verifyReCaptcha() {
    let data = {
      token: this.response
    }
    this.appServiceManager.post('branches/' + AuthService.getLoggedInBranch() + '/users/actions/validate-recaptcha', data).subscribe((res: any) => {
      if (res.success) {
        this.registerCompany();
      } else {
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'reCAPTCHA failed' });
      }
    },
      (error) => {
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      });
  }


  hotkeys($event) {
    if ($event.keyCode == 13) {
      var nextStep = this.enterSteps.length - 1 > this.currentStep ? this.currentStep + 1 : 0;
      var nextId = this.enterSteps[nextStep];
      let ele: any = document.getElementById(nextId)
      ele.focus();
      this.currentStep = nextStep;
    }
  }

  hotClick($event) {
    let currentClickLocation = $event.target.id;
    let indexOfClickField = this.enterSteps.indexOf(currentClickLocation);
    if (indexOfClickField !== -1) {
      this.currentStep = indexOfClickField;
    }
    else {
      this.currentStep = this.currentStep;
    }
  }

}
